export const LOCALES = ["en", "es", "pt"] as const;
export type Locale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: Locale = "en";

export type LocaleConfig = {
  label: string;
  shortLabel: string;
  pathPrefix: string;
  hrefLang: string;
  ogLocale: string;
  intlLocale: string;
  routeNoun: string;
  circuitNoun: string;
};

export const LOCALE_CONFIG: Record<Locale, LocaleConfig> = {
  en: {
    label: "English",
    shortLabel: "EN",
    pathPrefix: "",
    hrefLang: "en",
    ogLocale: "en_US",
    intlLocale: "en-US",
    routeNoun: "Route",
    circuitNoun: "Circuit",
  },
  es: {
    label: "Español",
    shortLabel: "ES",
    pathPrefix: "/es",
    hrefLang: "es",
    ogLocale: "es_PE",
    intlLocale: "es-PE",
    routeNoun: "Ruta",
    circuitNoun: "Circuito",
  },
  pt: {
    label: "Português",
    shortLabel: "PT",
    pathPrefix: "/pt",
    hrefLang: "pt-BR",
    ogLocale: "pt_BR",
    intlLocale: "pt-BR",
    routeNoun: "Rota",
    circuitNoun: "Circuito",
  },
};

const LOCALE_SET = new Set<string>(LOCALES);

export function normalizeLocale(raw: unknown): Locale {
  return typeof raw === "string" && LOCALE_SET.has(raw) ? (raw as Locale) : DEFAULT_LOCALE;
}

export function isSupportedLocale(raw: string): raw is Locale {
  return LOCALE_SET.has(raw);
}

export function nonDefaultLocales(): Locale[] {
  return LOCALES.filter((locale) => locale !== DEFAULT_LOCALE);
}
